import { render, staticRenderFns } from "./GuruForm.vue?vue&type=template&id=6f05f8af"
import script from "./GuruForm.vue?vue&type=script&lang=js"
export * from "./GuruForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports